export default __webpack_public_path__ + "static/media/img-ln-9-box.501fb397.png";